module.exports = __webpack_public_path__ + "img/mp-logo.564cb8f7.png";